export enum contractStatus {
    BLOCKED = "Bloqué",
    INACTIVE = "Inactif",
    ACTIVE = "Actif",
}

export const contractStatusBadges: Record<string, string> = {
    [contractStatus.BLOCKED]: "badge badge-danger",
    [contractStatus.INACTIVE]: "badge badge-warning",
    [contractStatus.ACTIVE]: "badge badge-success",
}